import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  IconButton,
  Modal,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import React, { memo, useCallback, useRef, useState } from "react";
import { BIGrey, BILightGrey } from "../../../assets/helpers";
import ReactSignatureCanvas from "react-signature-canvas";
import { Postrequestcall } from "../../../request/Postrequest";
import { useSelector } from "react-redux";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import {
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS_NEW_CREW,
  SAVE_CLIENT_TIMESHEETS_JOBS_EMPLOYEE_SIGNATURES
} from "../../../constant/Apipath";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

export default function ReviewTimeSheet({ isOpen, onClose, reviewData, reloadData }) {
  const [signBlob, setSignBlob] = useState(null);
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [checked, setChecked] = useState(false);

  const [loader, setLoader] = useState(false);

  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;
  CLIENT_COLOR = selectedClientData?.AccentColor;

  const {
    TEXT_REVIEW_TIMESHEET,
    TEXT_MILEAGE,
    TEXT_ACTIVITY,
    TEXT_SUBMIT,
    TEXT_TOTAL,
    TEXT_TIME_HOURS,
    TEXT_SIGNATURE,
    TEXT_CLEAR,
    TEXT_NOT_INJURED_TODAY
  } = ClientEnglishFallback?.ReviewTimesheet(multiLanguageData?.ReviewTimesheet || {});

  const getHoursValue = (activity) => {
    const hrValue = reviewData?.timesheetHoursList?.filter(
      (hr) =>
        hr.clientEmployeeId === selectedClientData?.ClientEmployeeId &&
        hr?.clientJobActivityId === activity?.clientActivityId
    );
    return hrValue?.[0]?.hours || 0.0;
  };

  const onTimesheetchange = (e) => {
    setChecked(e.target.checked);
  };

  const renderTotalHours = () => {
    let totalMinutes = 0;
    reviewData?.timesheetHoursList?.forEach((item) => {
      if(!item.hours) return;
      const [hh, mm] = item.hours.split(":").map(Number);
      if (!isNaN(hh) && !isNaN(mm)) {
        totalMinutes += hh * 60 + mm;
      }
    });
    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;
    // Format with leading zero if needed
    const formattedTotal = `${String(totalHours).padStart(2, "0")}:${String(totalRemainingMinutes).padStart(2, "0")}`;
    return formattedTotal ?? "0.00";
  };

   const convertTimeToDecimal = (timeStr) => {
    if (!timeStr || !timeStr.includes(":")) return "";
    const [hh, mm] = timeStr.split(":").map(Number);
    if (isNaN(hh) || isNaN(mm)) return "";
    const decimal = hh + mm / 60;
    return decimal.toFixed(2); // Keep 2 decimal places
  };

  // SUBMIT FUNCTION :
  const onSubmitPressed = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      const saveList = reviewData.timesheetActivitiesList?.map((act) => {
        const activityEmployeesList = reviewData.timesheetEmployeesList?.filter(
          (emp) => emp.clientEmployeeId === selectedClientData?.ClientEmployeeId
        ).map((emp) => {
          const hr = reviewData.timesheetHoursList?.find(
            (h) => h.clientEmployeeId === emp.clientEmployeeId && h.clientJobActivityId === act.clientActivityId
          );
          let getHours = hr ? Number(convertTimeToDecimal(hr.hours)) : 0;
          return {
            id: hr?.id || 0,
            clientEmployeeId: emp.clientEmployeeId,
            hours: getHours,
            employeeMileage: emp.mileage ? parseFloat(emp.mileage) : 0,
            employeeMileageUnit: emp.mileageUnit || "km",
            employeeUDFields: "",
            deleted: false,
            clockInTime: hr?.clockInTime && hr.clockInTime !== "00:00" ? moment(hr.clockInTime, ["h:mm A", "HH:mm", "hh:mm a"]).format("HH:mm:ss") : "00:00:00",
            clockOutTime: hr?.clockOutTime && hr.clockOutTime !== "00:00" ? moment(hr.clockOutTime, ["h:mm A", "HH:mm", "hh:mm a"]).format("HH:mm:ss") : "00:00:00",
            isHoursEdit: false,
            isEmployeeUDField: !!emp?.udFieldsList?.length,
            clockInLatitude: hr?.clockInLatitude || 0,
            clockOutLatitude: hr?.clockOutLatitude || 0,
            clockInLongitude: hr?.clockInLongitude || 0,
            clockOutLongitude: hr?.clockOutLongitude || 0,
            employeeStatusId: 1
          };
        });

        return {
          id: reviewData.clientTimesheetId || 0,
          userId: USER_ID,
          clientId: reviewData.clientId || selectedClientData?.ClientId,
          date: reviewData.date ? moment(reviewData.date).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
          statusId: reviewData.statusId || 1,
          typeId: reviewData.typeId,
          clientJobId: reviewData.clientJobId,
          jobNotes: reviewData.notes || "",
          jobUDFields: "",
          clientActivityId: act?.clientActivityId,
          activityQty: act?.qty || 0,
          activityQtyUnit: act?.qtyUnit || "",
          activityNotes: act?.notes || "",
          activityUDFields: "",
          deleted: false,
          isJobUDField: !!reviewData.udFieldsList?.length,
          isActivityUDField: !!act?.udFieldsList?.length,
          activityEmployeesList: activityEmployeesList || []
        };
      }) || [];

      const saveObject = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: saveList
      };

      // SAVE TIMESHEET   : -------------->
      const save_response = await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW_CREW, saveObject, TOKEN);
      if (save_response.status === 201) {
        // SAVE IMAGES  : -------------->
        reviewData.timesheetActivitiesList?.map((act) => {
          if (act.pictureList?.length > 0) {
            act.pictureList?.map(async (images, index) => {
              if (images.isNew) {
                const formData = new FormData();
                formData.append("Id", 0);
                formData.append("ClientTimesheetJobId", reviewData?.id);
                formData.append("ClientJobId", reviewData?.clientJobId);
                formData.append("ClientActivityId", act.clientActivityId);
                formData.append("FileName", images.file);
                formData.append("ModifiedBy", USER_ID);
                formData.append("ClientTimesheetId", reviewData?.clientTimesheetId);
                formData.append("ClientEmployeeId", selectedClientData?.ClientEmployeeId);
                const res = await Postrequestcall(
                  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
                  formData,
                  TOKEN,
                  true
                );
              }
            });
          }
        });

        // SAVE SIGNATURE  : -------------->
        //if (uri != "") {
        reviewData.timesheetEmployeesList?.map(async (emp) => {
          if (emp.clientEmployeeId == selectedClientData?.ClientEmployeeId) {
            const formdata = new FormData();
            formdata.append("Id", 0);
            formdata.append("ClientTimesheetJobEmployeeId", Number(emp.id));
            formdata.append("IsInjured", checked);
            formdata.append("Signature", signBlob);
            formdata.append("ModifiedBy", USER_ID);
            await Postrequestcall(
              SAVE_CLIENT_TIMESHEETS_JOBS_EMPLOYEE_SIGNATURES,
              formdata,
              TOKEN,
              true
            );
          }
        });
        onClose();
        reloadData();
      }
    } catch (e) {
      console.log("onSubmitPressed-> Error When Saving Client Timesheet: ", e);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          padding: {
            xs: "10px",
            xl: "15px",
            lg: "15px",
            md: "15px",
            sm: "10px"
          }
        }}
        className="client-modal-responsive"
        minHeight={"500px"}>
        {loader ? (
          <Box sx={{ width: "100%" }}>
            <TimesheetSkeletonLoader variant="detail" />
          </Box>
        ) : (
          <>
            <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
              <>
                <Typography variant="h6">{TEXT_REVIEW_TIMESHEET}</Typography>
                <Stack sx={{ gap: 1 }} direction={"row"} >
                  <IconButton size="small" onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </Stack>
              </>
            </Stack>
            <Card
              className="pagelist-content"
              style={{ padding: "10px", marginTop: "10px", marginBottom: "12px" }}>
              <Stack sx={{ gap: 1 }} >
                <Typography
                  style={{
                    color: BIGrey
                  }}
                  variant="body1">
                  {`${moment(reviewData?.date).format("MMMM DD, YYYY")}`}
                </Typography>
                <Typography>{`${reviewData?.clientJobCode} - ${reviewData?.clientJobName}`}</Typography>
              </Stack>
              <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
                <Typography sx={{ color: BIGrey }}>{TEXT_MILEAGE}</Typography>
                {reviewData.timesheetEmployeesList?.map(
                  (emp, index) =>
                    emp?.clientEmployeeId === selectedClientData?.ClientEmployeeId && (
                      <Typography>{`${emp?.mileage} ${emp?.mileageUnit}`}</Typography>
                    )
                )}
              </Stack>
            </Card>
            <Card className="pagelist-content">
              <TableContainer component={Paper}>
                <Table
                  sx={{
                    minWidth: 350,
                    "& th": { color: BIGrey, padding: "7px", borderBottom: "0px" }
                  }}
                  aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{TEXT_ACTIVITY}</TableCell>
                      <TableCell align="right">{TEXT_TIME_HOURS}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reviewData.timesheetActivitiesList?.map((activity, act_index) => (
                      <TableRow
                        key={act_index}
                        sx={{ "& td, & th": { border: 0, padding: "7px" } }}>
                        <TableCell>
                          {`${activity.clientJobActivityCode} - ${activity.clientJobActivityName}`}
                        </TableCell>
                        <TableCell align="right">{getHoursValue(activity)}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell>{TEXT_TOTAL}</TableCell>
                      <TableCell align="right">{renderTotalHours()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
            <Stack>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: CLIENT_COLOR,
                      "&.Mui-checked": {
                        color: CLIENT_COLOR
                      }
                    }}
                    checked={checked}
                    onChange={(e) => onTimesheetchange(e)}
                  />
                }
                label={TEXT_NOT_INJURED_TODAY}
              />
              <Stack>
                <Typography sx={{ mb: 1 }}>{TEXT_SIGNATURE}</Typography>
                <Box
                  sx={{
                    position: "relative"
                  }}>
                  <SignaturePadMemo setBlob={setSignBlob} TEXT_CLEAR={TEXT_CLEAR} />
                </Box>
              </Stack>
              <Button
                fullWidth
                disabled={signBlob === null ? true : false}
                onClick={(e) => onSubmitPressed(e)}
                style={{ color: "white" }}
                sx={{
                  textTransform: "none",
                  color: "#ffff",
                  borderRadius: "10px",
                  backgroundColor:
                    signBlob === null ? BILightGrey : selectedClientData?.AccentColor,
                  marginTop: "10px"
                }}>
                {TEXT_SUBMIT}
              </Button>
            </Stack>
          </>
        )}
      </Box>
    </Modal>
  );
}

const SignaturePad = ({ setBlob, TEXT_CLEAR }) => {
  const signPadRef = useRef();
  const [showClear, setShowClear] = useState(false);

  const ClickableText = styled(Typography)(({ theme }) => ({
    cursor: "pointer",
    transition: " color 0.1s ease",
    "&:hover": {},
    userSelect: "none",
    "&:active": {
      color: "lightgrey"
    }
  }));

  const getSignImg = useCallback(() => {
    const canvas = signPadRef.current.getCanvas();
    if (!canvas) return;
    canvas.toBlob(
      (blob) => {
        setBlob(blob);
      },
      "image/png",
      1.0
    );
  }, []);

  return (
    <div style={{ width: "100%", maxWidth: "600px", margin: "0 auto" }}>
      <ReactSignatureCanvas
        onBegin={() => {}}
        clearOnResize={false}
        ref={signPadRef}
        penColor="black"
        onEnd={() => {
          setShowClear(true);
          getSignImg();
        }}
        canvasProps={{
          className: "sigCanvas"
        }}
      />
      <style>
        {`
          .sigCanvas {
            width: 100% !important;
            height: 150px !important;
            border: 1px solid #e4e4e4; 
            border-radius: 10px;
          }
        `}
      </style>
      {showClear && (
        <ClickableText
          onClick={() => {
            signPadRef.current.clear();
            setShowClear(false);
            setBlob(null);
          }}
          variant="body2"
          size="small"
          sx={{
            position: "absolute",
            top: 2,
            right: 7,
            zIndex: 100,
            color: CLIENT_COLOR
          }}>
          {TEXT_CLEAR}
        </ClickableText>
      )}
    </div>
  );
};

const SignaturePadMemo = memo(SignaturePad);

